import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '@make-software/cspr-design';
import HamburgerIcon from '@/assets/icons/hamburger-menu.svg';

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  color: theme.styleguideColors.contentTertiary,
  ':hover, :active': {
    color: theme.styleguideColors.contentOnFill
  }
}));

interface HamburgerButtonProps {
  onClick?: () => void;
}

const HamburgerButton: React.FC<HamburgerButtonProps> = ({ onClick } ) => {
  return <StyledSvgIcon src={HamburgerIcon} size={16} onClick={onClick} />;
};

export default HamburgerButton;